import { jsx as _jsx } from "react/jsx-runtime";
import { LocalDate, toLocalDate } from '@spa-frontend/date-lib';
import React from 'react';
import { IconCake } from '../icon';
import { Chip } from '.';
export const BirthdayChip = (props) => {
    if (!hasBirthday(props.timezone, props.dateOfBirth)) {
        return null;
    }
    return (_jsx(Chip, { sx: {
            transform: 'scale(0.8)'
        }, icon: _jsx(IconCake, { color: "components.chip.additional-colour-coding.mail.contrastText" }), color: "mail" }));
};
const hasBirthday = (timezone, dateOfBirth) => {
    if (!dateOfBirth || !timezone) {
        return false;
    }
    const d = toLocalDate(dateOfBirth);
    return d.isSameDay(LocalDate.now(timezone).setYear(d.getFullYear()));
};
